// Bot training / FAQ content -- specific Q&A the owner wants the IVR to be
// able to answer. Exposed read-only to the external IVR bot via
// get-ivr-knowledge-base (tenant-API-key authenticated). Saving an entry
// here does NOT make the bot answer it -- that requires the external IVR
// codebase to actually call that endpoint, a separate integration step.
import { supabase } from '@/lib/supabase';

export interface IvrKnowledgeEntry {
  id: string;
  tenant_id: string;
  question: string;
  answer: string;
  sort_order: number;
  is_active: boolean;
}

export async function loadKnowledgeBase(tenantId?: string | null): Promise<IvrKnowledgeEntry[]> {
  let q = supabase.from('ivr_knowledge_base').select('*').order('sort_order', { ascending: true });
  if (tenantId) q = q.eq('tenant_id', tenantId);
  const { data, error } = await q;
  if (error) {
    console.error('Error loading IVR knowledge base:', error);
    return [];
  }
  return (data as IvrKnowledgeEntry[]) || [];
}

export async function saveKnowledgeEntry(
  entry: Partial<IvrKnowledgeEntry> & { question: string; answer: string },
  tenantId: string | null,
): Promise<void> {
  const payload = {
    tenant_id: tenantId,
    question: entry.question.trim(),
    answer: entry.answer.trim(),
    sort_order: entry.sort_order ?? 100,
    is_active: entry.is_active ?? true,
    updated_at: new Date().toISOString(),
  };
  const { error } = entry.id
    ? await supabase.from('ivr_knowledge_base').update(payload).eq('id', entry.id)
    : await supabase.from('ivr_knowledge_base').insert([payload]);
  if (error) throw error;
}

export async function toggleKnowledgeEntryActive(entry: IvrKnowledgeEntry): Promise<void> {
  const { error } = await supabase
    .from('ivr_knowledge_base')
    .update({ is_active: !entry.is_active, updated_at: new Date().toISOString() })
    .eq('id', entry.id);
  if (error) throw error;
}

export async function deleteKnowledgeEntry(id: string): Promise<void> {
  const { error } = await supabase.from('ivr_knowledge_base').delete().eq('id', id);
  if (error) throw error;
}
